import { motion } from "framer-motion";

export default function EmptyState({ icon: Icon, title, description, action, testid = "empty-state" }) {
  return (
    <motion.div initial={{ opacity: 0, y: 8 }} animate={{ opacity: 1, y: 0 }}
      data-testid={testid}
      className="flex flex-col items-center justify-center rounded-2xl border border-dashed border-slate-200 bg-white/60 px-6 py-12 text-center">
      <div className="relative mb-3">
        <img src="/favicon.png" alt="" className="floaty h-24 w-auto object-contain [filter:drop-shadow(0_8px_16px_rgba(124,110,255,0.28))]" />
        {Icon && <span className="absolute -bottom-1 right-0 flex h-8 w-8 items-center justify-center rounded-full bg-gradient-to-br from-blue-500 to-purple-500 text-white shadow-md"><Icon className="h-4 w-4" /></span>}
      </div>
      <h3 className="text-lg font-semibold text-slate-800">{title}</h3>
      {description && <p className="mt-1 max-w-md text-sm text-slate-500">{description}</p>}
      {action && <div className="mt-5">{action}</div>}
    </motion.div>
  );
}
